export default __webpack_public_path__ + "media/images/get-ready/purposes-e40d6949cec4c70fa244d46fa9c2796d.png";